import objectHash from 'object-hash'
import type { Feature, MultiPolygon, Polygon } from 'geojson'
import { childrenItemViewLabels } from '../variable/spaceTime.data'
import type { Layer, Space, SpaceChildrenItemView } from '../variable/spaceTime.types'

export const agentPolygonDemarcationSource = 'agentPolygon'
export const manualDemarcationSource = 'manual'

export type DemarcationSource =
  | typeof agentPolygonDemarcationSource
  | typeof manualDemarcationSource

export type DemarcationFeatureProperties = {
  hash: string
  source?: DemarcationSource
  filterGeometry?: Polygon | MultiPolygon
}

export type DemarcationFeatureWithHash = Feature<
  Polygon | MultiPolygon,
  DemarcationFeatureProperties
>

const resolveChildrenItemView = (layer: Layer): 'cluster' | 'heatmap' => {
  if (layer.space.childrenType !== 'item') {
    return 'heatmap'
  }

  return layer.space.childrenItemView === 'cluster' ? 'cluster' : 'heatmap'
}

export const buildDemarcationFeatureWithHash = (
  geometry: Polygon | MultiPolygon | null,
  source?: DemarcationSource,
  filterGeometry?: Polygon | MultiPolygon | null,
): DemarcationFeatureWithHash | null => {
  if (!geometry) {
    return null
  }

  const hash = objectHash(geometry.coordinates)
  const filterGeometryHash = filterGeometry ? objectHash(filterGeometry.coordinates) : null

  return {
    type: 'Feature',
    geometry,
    properties: {
      hash,
      source,
      ...(filterGeometry && filterGeometryHash !== hash ? { filterGeometry } : {}),
    },
  }
}

export const buildLayerWithCustomPolygonDelimitation = (
  layer: Layer,
  polygonDemarcation: DemarcationFeatureWithHash,
): Layer => {
  const childrenItemView = resolveChildrenItemView(layer)

  const space: Space = {
    ...layer.space,
    delimitationTitle: 'Demarcação por polígono',
    delimitationType: 'custom',
    delimitationCustom: polygonDemarcation,
    childrenType: 'item',
    childrenItemView,
    childrenTitle: childrenItemViewLabels[childrenItemView],
  }

  return {
    ...layer,
    space,
  }
}
